export default {
  namespaced: true,
  actions: {
    create({ commit, state }, bundle) {
      return Vue.$http.post('client/document_bundles', { bundle }).then(
        response => {
          commit(
            'snackbar',
            {
              text: 'Document bundle has been queued. Download link will be mailed shortly.',
              type: 'success'
            },
            { root: true }
          )
        },
        errors => {
          state.loading = false
          commit(
            'snackbar',
            {
              text: 'There was a problem requesting the document bundle',
              type: 'error'
            },
            { root: true }
          )
        }
      )
    }
  }
}
